<template>
  <div class="ocean-ui-dialog-page" :class="{ 'has-other-tips': tips }">
    <transition name="scale-in" @after-leave="closeDialog">
      <Block
        v-if="showContent"
        type="tipsDialog"
        tagName="article"
        class="dialog-container tips-dialog"
      >
        <Block type="tipsDialogWrapper" class="tips-dialog-wrapper">
          <Title type="dialogTitle" class="dialog-title">{{ myTitle }}</Title>

          <Content
            type="tipsContent"
            class="tips-content"
            :class="textAlign"
            v-html="content"
          ></Content>
          <p v-if="tips" class="tips-tips">{{ tips }}</p>
          <Block
            v-if="type == 'tips'"
            type="dialogBtnDocker"
            tagName="footer"
            class="account-ops"
          >
            <Button
              type="fillLightDialog"
              class="swtich-account btn"
              pointClass="j-sure-tip-btn"
              @click="sendConfirmEvt"
              v-touchActive
            >
              <Icon type="commonBtnLeft"></Icon>
              <Icon type="commonBtnRight"></Icon>
              {{ myConfirm }}
            </Button>
          </Block>
          <Block
            v-else
            type="dialogBtnDocker"
            tagName="footer"
            class="account-ops"
          >
            <Button
              type="shortCancel"
              class="cencel-account btn"
              pointClass="j-cancle-tip-btn"
              @click="sendCancelEvt"
              v-touchActive
            >
              {{ myCancel }}
            </Button>
            <Button
              type="shortConfirm"
              class="swtich-account btn"
              pointClass="j-sure-tip-btn"
              @click="sendConfirmEvt"
              v-touchActive
            >
              {{ myConfirm }}
            </Button>
          </Block>
        </Block>
        <Button
          type="closeBtn"
          class="close-btn"
          pointClass="j-close-tip-btn"
          @click="hideContent"
          v-touchActive
        ></Button>
      </Block>
    </transition>
    <transition name="fade-in">
      <div
        v-if="showContent"
        @click="hideContent"
        class="ocean-ui-dialog-buttom"
      ></div>
    </transition>
  </div>
</template>

<script>
export const CLOSE_DIALOG_EVENT = 'close_dialog';
export const CANCEL_EVENT = 'onCancel';
export const CONFIRM_EVENT = 'onConfirm';
export const SHOW_TIPS = 'showTipsDialog';
export const RESET_CONFIG = 'resetConfig';
export default {
  props: [
    'content',
    'title',
    'cancel',
    'confirm',
    'languages',
    'type',
    'tips',
    'textAlign',
  ],
  data() {
    return {
      showContent: false,
      operateType: '',
    };
  },
  computed: {
    myTitle() {
      let tips = '';
      try {
        tips = this.title || this.languages.tips.toUpperCase();
      } catch {
        tips = 'tips';
      }
      return tips;
    },
    myCancel() {
      let cancel = '';
      try {
        cancel = this.cancel || this.languages.cancel.toUpperCase();
      } catch {
        cancel = 'CANCEL';
      }
      return cancel;
    },
    myConfirm() {
      let confirm = '';
      try {
        confirm = this.confirm || this.languages.confirm.toUpperCase();
      } catch {
        confirm = 'COMFIRM';
      }
      return confirm;
    },
  },
  methods: {
    closeDialog() {
      if (this.type === 'newPopupWindow' && this.operateType === 'confirm') {
        this.$emit(CONFIRM_EVENT);
        return;
      }
      this.$emit(CANCEL_EVENT);
      if (this.operateType === 'confirm') {
        this.$emit(CONFIRM_EVENT);
      }
    },
    hideContent() {
      this.showContent = false;
    },
    sendCancelEvt() {
      this.hideContent();
      // this.$emit(CANCEL_EVENT);
      this.operateType = 'cancel';
    },
    sendConfirmEvt() {
      this.hideContent();
      // this.$emit(CONFIRM_EVENT);
      this.operateType = 'confirm';
    },
  },
  mounted() {
    this.showContent = true;
  },
  beforeDestroy() {
    this.showContent = false;
  },
};
</script>

<style scoped lang="scss">
$h6Fz: 18px;
$btnH: 54px;
$deeppGray: #414141;
$lightGray: #949494;
$lightGrayBroder: #a7a7a7;
$contentFz: 24px;
$green: #57ae67;
$greenBorder: #76bc83;
$linghtGrayBg: #f3f3f3;
$shortBtnW: 210px;
$longBtnW: 420px;
$radius: 20px;
$closeDlgBtnH: 24px;
$closeDlgBtnW: 24px;
$closeDlgBtnBt: 30px;

$tostW: 597px;
$tostLH: 48px;
$tostFz: 28px;

//passport
$passportContentW: 530px;
$functionH: 95px;

$functionL: 78px;
$functionBtm: 10px;
$headerBtm: 20px;
$dialogW: 550px;
$dialogH: 308px;
$dialogTitleFz: 34px;
$tipsContentFz: 18px;
$tipsContentLh: 56px;
$bindAccountIconW: 94px;
$bingWayNameLineH: 18px;
$bindAccountIconMb: 20px;
//passport 横屏
$functionHLan: 90px;
$functionWLan: 482px;

%btn {
  height: $btnH;
  line-height: $btnH;
  color: white;
  text-align: center;
  font-size: 26px;
}

.ocean-ui-dialog-page {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 30;
}
.my-tips-dialog {
  position: relative;
  width: 550px;
  min-height: 308px;
  background: white;
  z-index: 10;
  padding: 14px;
  padding-top: 10px;
  box-sizing: border-box;

  .tips-dialog-wrapper {
    width: 100%;
    height: 100%;
    min-height: 284px;
    background: $linghtGrayBg;
  }
}

@mixin btn($bgColor, $width) {
  @extend %btn;
  width: $width;
  background-color: $bgColor;
}

%textOverflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@mixin shortBtn($bgColor) {
  @extend %btn;
  width: $shortBtnW;
  background-color: $bgColor;
}

@mixin LongBtn($bgColor) {
  @extend %btn;
  width: $longBtnW;
  background-color: $bgColor;
}
.tips-dialog-close-btn {
  position: absolute;
  right: 20px;
  top: 10px;
  width: $closeDlgBtnW;
  height: $closeDlgBtnH;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAASFBMVEUAAADeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmLeYmIAAABzNIkRAAAAFnRSTlMAJBGb9FRV850f/FZXIA73D/aiJhMn6CGLBwAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAACCSURBVCjPdZHZEoMgDEWv1oJCXIv5/0+1tLXDdnmAyTlDQgKArkex+i7uDx2eOTdWR2BSVedTLu6NZixrNFLwdQO8y8yHf1NIalggretS8T+o+G1q/jMNfpuaU8FSseLsuaxBNhIWmNZ1Ayy2VdBumNnXYtTd5E35XY94vkI5hnACF2dREO0np1xMAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTEyLTI3VDExOjI5OjM0KzA4OjAwoLiNLQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0xMi0yN1QxMToyOTozNCswODowMNHlNZEAAAAASUVORK5CYII=);
  background-size: 100% 100%;
  z-index: 10;
  border-radius: $closeDlgBtnH;
}

.diaglog-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 1001;
}

.dialog-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.dialog-container {
  position: relative;
  width: $dialogW;
  min-height: $dialogH;
  background: white;
  z-index: 10;
}

.tips-dialog-title {
  width: 100%;
  float: left;
  margin-top: 37px;
  margin-bottom: 25px;
  text-align: center;
  font-size: $dialogTitleFz;
}

.tips-dialog-content {
  vertical-align: middle;
  width: 342px;
  height: $tipsContentLh;
  padding: 0 71.5px;
  margin: 0 auto;
  text-align: center;
  font-size: $tipsContentFz;
  line-height: 26px;
  clear: both;
}

.tips-dialog-ops {
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: $btnH;
  margin-top: 50px;
}

.tips-dialog-cancel-btn {
  @include shortBtn($lightGray);
  box-sizing: border-box;
  border: 1px solid $lightGrayBroder;
}

.tips-dialog-confirm-btn {
  @include shortBtn($green);
  box-sizing: border-box;
  border: 1px solid $greenBorder;
}
.longBtn {
  width: $longBtnW !important;
}

.ocean-ui-dialog-buttom {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}
.left {
  text-align: left;
}
.center {
  display: block;
  box-sizing: border-box;
}
</style>
